const firebaseConfig = {
  apiKey: "AIzaSyB7uV84HDvwFLq17scbtsdzW1kbA8A0w_w",
  authDomain: "hr-care-6befb.firebaseapp.com",
  projectId: "hr-care-6befb",
  storageBucket: "hr-care-6befb.appspot.com",
  messagingSenderId: "106619355149",
  appId: "1:106619355149:web:63630dff5bafb801549544"
};
export default firebaseConfig;
